import { render } from "./MissedOpportunityPage.vue?vue&type=template&id=3ee66dc4"
import script from "./MissedOpportunityPage.vue?vue&type=script&lang=js"
export * from "./MissedOpportunityPage.vue?vue&type=script&lang=js"

import "./MissedOpportunityPage.vue?vue&type=style&index=0&id=3ee66dc4&lang=css"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__